import { useEffect } from 'react'

import { NodeTypes } from '../types'
import { useDebounce } from './use-debounce'

export const useAutoSave = (
  nodes: NodeTypes[],
  save: (origin: string) => Promise<void>
) => {
  const debouncedNodes = useDebounce(nodes, 5000)
  useEffect(() => {
    const interval = setInterval(async () => {
      await save('automation')
    }, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [save, debouncedNodes])
}
